export const achievementData = {
    bio: "Continuous learning and industry-recognized certifications validating technical competency.",
    achievements: [
        {
            id: 1,
            title: 'Microsoft Azure Fundamentals (AZ-900)',
            details: 'Certified in cloud concepts, Azure core architecture, identity governance, privacy compliance, and cloud security features.',
            date: '2024',
            field: 'Cloud Infrastructure',
            image: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800&auto=format&fit=crop&q=80'
        },
        {
            id: 2,
            title: 'Full Stack MERN & Rails Architecture',
            details: 'Built 4+ end-to-end production systems with authentication, WebSocket channels, relational schemas, and sub-100ms response targets.',
            date: '2025',
            field: 'System Design',
            image: 'https://images.unsplash.com/photo-1555066931-4365d14bab8c?w=800&auto=format&fit=crop&q=80'
        }
    ]
};
